import React from 'react';
import { Search, X, Filter } from 'lucide-react';

const FilterBar = ({ 
  filters, 
  availableFilters, 
  plays, 
  onFilterChange, 
  onClearFilters 
}) => {
  const hasActiveFilters = 
    filters?.playId || 
    filters?.act || 
    filters?.scene || 
    filters?.character || 
    filters?.searchQuery;

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4 mb-6">
      <div className="flex items-center space-x-2 mb-4">
        <Filter className="w-5 h-5 text-gray-600" />
        <h2 className="text-lg font-semibold text-gray-900">Filters</h2>
        {hasActiveFilters && (
          <button
            onClick={onClearFilters}
            className="ml-auto text-sm text-purple-600 hover:text-purple-700 font-medium flex items-center space-x-1"
          >
            <X className="w-4 h-4" />
            <span>Clear All</span>
          </button>
        )}
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4">
        {/* Search Input */}
        <div className="lg:col-span-2">
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Search
          </label>
          <div className="relative">
            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400" />
            <input
              type="text"
              value={filters?.searchQuery}
              onChange={(e) => onFilterChange('searchQuery', e?.target?.value)}
              placeholder="Search by Line ID, Character, or Text..."
              className="w-full pl-10 pr-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent"
            />
          </div>
        </div>

        {/* Play Filter */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Play
          </label>
          <select
            value={filters?.playId}
            onChange={(e) => onFilterChange('playId', e?.target?.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent"
          >
            <option value="">All Plays</option>
            {plays?.map(play => (
              <option key={play?.play_id} value={play?.play_id}>
                {play?.title}
              </option>
            ))}
          </select>
        </div>

        {/* Act Filter */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Act
          </label>
          <select
            value={filters?.act}
            onChange={(e) => onFilterChange('act', e?.target?.value)}
            disabled={!filters?.playId}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent disabled:bg-gray-100 disabled:cursor-not-allowed"
          >
            <option value="">All Acts</option>
            {availableFilters?.acts?.map(act => (
              <option key={act} value={act}>
                Act {act}
              </option>
            ))}
          </select>
        </div>

        {/* Scene Filter */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Scene
          </label>
          <select
            value={filters?.scene}
            onChange={(e) => onFilterChange('scene', e?.target?.value)}
            disabled={!filters?.playId}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent disabled:bg-gray-100 disabled:cursor-not-allowed"
          >
            <option value="">All Scenes</option>
            {availableFilters?.scenes?.map(scene => (
              <option key={scene} value={scene}>
                Scene {scene}
              </option>
            ))}
          </select>
        </div>
      </div>
      {/* Character Filter - Full Width */}
      <div className="mt-4">
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Character
        </label>
        <select
          value={filters?.character}
          onChange={(e) => onFilterChange('character', e?.target?.value)}
          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent"
        >
          <option value="">All Characters</option>
          {availableFilters?.characters?.map(character => (
            <option key={character} value={character}>
              {character}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default FilterBar;